export enum FlightReservationReportKeys {
  registrationStatus = 'registrationStatus',
  dob = 'dob',
  gender = 'gender',
  inviteeEmail = 'inviteeEmail',
  ccEmail = 'ccEmail',
  phoneNumber = 'phoneNumber',
  flightInformation = 'flightInformation',
  flightInformationUniqueId = 'flightInformationUniqueId',
  taskOwner = 'taskOwner',
  taskStatus = 'taskStatus',
  attendeeType = 'attendeeType',
  inviteeStatus = 'inviteeStatus',
  inviteeOutcomeStatus = 'inviteeOutcomeStatus',
  registrationType = 'registrationType',
  homeAddress = 'homeAddress',
  hotelAddress = 'hotelAddress',
  milesDriven = 'milesDriven',
  mileageRate = 'mileageRate',
  totalToBePaid = 'totalToBePaid',
}
